import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import AddIcon from '@material-ui/icons/Add';
import ListItemText from '@material-ui/core/ListItemText';
import React from 'react';
import Typography from '@material-ui/core/Typography';

const getTitle = (widget) => {
  return widget.title || widget.name;
};
const AddWidgetDialog = (props) => {
  const { widgets, handleAdd } = props;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(DialogTitle, null, "Add new widget to dashboard"), /* @__PURE__ */ React.createElement(DialogContent, null, /* @__PURE__ */ React.createElement(List, { dense: true }, widgets.map((widget) => {
    return /* @__PURE__ */ React.createElement(
      ListItem,
      {
        key: widget.name,
        button: true,
        onClick: () => handleAdd(widget)
      },
      /* @__PURE__ */ React.createElement(ListItemAvatar, null, /* @__PURE__ */ React.createElement(AddIcon, null)),
      /* @__PURE__ */ React.createElement(
        ListItemText,
        {
          secondary: widget.description && /* @__PURE__ */ React.createElement(
            Typography,
            {
              component: "span",
              variant: "caption",
              color: "textPrimary"
            },
            widget.description
          ),
          primary: /* @__PURE__ */ React.createElement(Typography, { variant: "body1", color: "textPrimary" }, getTitle(widget))
        }
      )
    );
  }))));
};

export { AddWidgetDialog };
//# sourceMappingURL=AddWidgetDialog.esm.js.map
